<template>
  <v-app-bar
    :color="background"
    height="auto"
    class="py-2 px-0 border-radius-lg toolbar-content-padding-y-none text-white"
    :class="
      navbarFixed
        ? 'position-sticky blur top-1 py-2'
        : ''
    "
    style="background-color: rgba(236, 236, 236, 0.1) !important; z-index: 10;"
    flat
  >
    <v-row class="py-1">
      <v-col cols="7" class="d-flex">
        <div>
          <v-breadcrumbs class="pb-0 pt-1 px-0">
            <v-breadcrumbs-item
              to="/admin/profile_overview"
              active-class="active-breadcrumb"
            >
              <svg
                width="12px"
                height="12px"
                class="mb-1"
                viewBox="0 0 45 40"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <title>Información general del perfil</title>
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    transform="translate(-1716.000000, -439.000000)"
                    fill="#FFFFFF"
                    fill-rule="nonzero"
                  >
                    <g transform="translate(1716.000000, 291.000000)">
                      <g transform="translate(0.000000, 148.000000)">
                        <path
                          d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z"
                        ></path>
                        <path
                          d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </v-breadcrumbs-item>
            <li class="v-breadcrumbs__divider opacity-5 px-2 text-muted">/</li>
            <v-breadcrumbs-item 
              :class="textColor"
            >
              {{ $route.meta.groupName }}
            </v-breadcrumbs-item>
            <li class="v-breadcrumbs__divider opacity-5 px-2 text-muted">/</li>
            <v-breadcrumbs-item
              active-class="active-breadcrumb"
              class="no-default-hover"
            >
              <template>{{ (this.$route.params.section) ? this.$route.params.section : $route.meta.name_es }}</template>
            </v-breadcrumbs-item>
          </v-breadcrumbs>
          <!-- 
          <h6 class="text-h6 font-weight-bolder mb-0"
            :class="textColor">
            {{ (this.$route.params.section) ? this.$route.params.section : $route.meta.name_es }}
          </h6> 
          -->
        </div>
        <!--
        <div
          class="drawer-toggler pa-5 ms-6 cursor-pointer"
          :class="{ active: togglerActive }"
          @click="minifyDrawer"
          v-if="!$vuetify.breakpoint.mobile"
        >
          <div class="drawer-toggler-inner">
            <i class="drawer-toggler-line bg-body"></i>
            <i class="drawer-toggler-line bg-body"></i>
            <i class="drawer-toggler-line bg-body"></i>
          </div>
        </div>
        -->
      </v-col>

      <v-col
        cols="5"
        class="d-flex align-center"
        :class="$vuetify.rtl ? 'text-sm-left' : 'text-sm-right'"
      >
        <v-form
          v-if="hasBg"
          @submit.prevent="submit"
          class="navbar-search navbar-search-light d-inline-block ms-auto"
          id="navbar-search-main"
        >
          <v-text-field
            rounded-sm
            background-color="transparent"
            color="#e91e63"
            dense
            hide-details
            outlined
            label="Search here"
            class="input-style font-size-input me-md-3"
          >
          </v-text-field>
        </v-form>

        <!--         
        <v-btn
          v-if="$vuetify.breakpoint.mobile"
          icon
          title="Go to main page"
          :ripple="false"
          class="btn-dark-hover px-5"
          :class="textColor"
          :color="linkColor"
          small
          @click="$emit('toggleSettingsDrawer', true)"
        >
          <v-icon class="material-icons-round" size="20"> menu </v-icon>
        </v-btn> 
        -->

        <v-btn
          icon
          :ripple="false"
          :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
          class="text-white px-3 font-weight-bold"
          small
          :href="regularDomain+$route.fullPath"
        >
        <!-- @click="window.location.host = regularDomain" -->
          <label class="ma-0 pa-0 notranslate"
            :class="!actualDomain.includes('en.') ? 'selected-language font-weight-bold': ''"
          >
            ES
          </label>
        </v-btn>
        <p class="pa-0 ma-0" style="color: #FFFFFF; display: inline;">/</p>
        <v-btn
          icon
          :ripple="false"
          :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg } + ' ' + actualDomain.includes('en.') ? 'selected-language': ''"
          class="text-white px-3"
          small
          :href="englishDomain+$route.fullPath"
        >
        <!-- @click="window.location.host = englishDomain" -->
          <label class="ma-0 pa-0 notranslate"
            :class="actualDomain.includes('en.') ? 'selected-language font-weight-bold': ''"
          >
            EN
          </label>
        </v-btn>

        <v-btn
          title="Ir a la vista principal"
          :ripple="false"
          class="btn-dark-hover px-5"
          :class="textColor"
          :color="linkColor"
          small
          to="/"
          text
        >
          <v-icon class="material-icons-round mr-2" size="20"> web </v-icon>
          Vista principal
        </v-btn>

        <v-btn
          title="Cerrar sesión"
          :ripple="false"
          class="btn-dark-hover"
          :class="textColor"
          :color="linkColor"
          small
          text
          @click="logoutUser"
        >
          <v-icon class="material-icons-round me-sm-1 mr-2" size="20">
            logout
          </v-icon>
          Cerrar sesión
        </v-btn>

        <!--
        <v-btn
          elevation="0"
          :ripple="false"
          height="43"
          class="
            font-weight-600
            text-capitalize
            drawer-toggler
            py-3
            px-0
            rounded-sm
          "
          :class="{
            'btn-dark-toggler-hover': !hasBg,
            'btn-toggler-hover': hasBg,
            active: togglerActive,
          }"
          v-if="$vuetify.breakpoint.mobile"
          color="transparent"
          @click="drawerClose"
        >
          <div class="drawer-toggler-inner">
            <i class="drawer-toggler-line text-body"></i>
            <i class="drawer-toggler-line text-body"></i>
            <i class="drawer-toggler-line text-body"></i>
          </div>
        </v-btn>
        -->

        <!--
        <v-btn
          icon
          :ripple="false"
          class="btn-dark-hover px-5"
          :class="textColor"
          :color="linkColor"
          small
          @click="$emit('toggleSettingsDrawer', true)"
        >
          <v-icon class="material-icons-round" size="20"> settings </v-icon>
        </v-btn>
        -->

        <!--
        <v-menu
          transition="slide-y-transition"
          offset-y
          offset-x
          min-width="300"
          max-width="300"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              :ripple="false"
              class="btn-dark-hover px-5"
              :class="textColor"
              :color="linkColor"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon class="material-icons-round" size="20">
                notifications
              </v-icon>
              
              <v-badge
                color="secondary_gradient_background"
                content="11"
                offset-x="1"
                offset-y="0"
                class="position-absolute"
              />
            </v-btn>
          </template>

          <v-list class="pa-3">
            <v-list-item
              v-for="(item, i) in dropdown"
              :key="i"
              class="
                pa-4
                list-item-hover-active
                d-flex
                align-items-center
                py-1
                my-1
                border-radius-md
              "
            >
              <v-icon class="material-icons-round text-body" size="20">{{
                item.icon
              }}</v-icon>

              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-body-2 ls-0 font-weight-600 mb-0"
                  :class="textColor"
                >
                  <v-row>
                    <v-col>
                      <h6
                        class="text-sm font-weight-normal ms-2"
                        :class="textColor"
                      >
                        {{ item.title }}
                      </h6>
                    </v-col>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          
        </v-menu>
        -->
      </v-col>
    </v-row>
  </v-app-bar>
</template>
<script>

import Api from '@/api/Api';

export default {
  name: "app-bar",
  props: {
    background: String,
    hasBg: Boolean,
    linkColor: String,
    toggleActive: Boolean,
    textColor: {
      type: String,
      default: 'text-white'
    },
    navbarFixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawer: false,
      togglerActive: false,
      dropdown: [
        {
          icon: "email",
          title: "Check new messages",
        },
        {
          icon: "podcasts",
          title: "Manage podcast session",
        },
        {
          icon: "shopping_cart",
          title: "Payment successfully completed",
        },
      ],
    };
  },
  computed: {
    englishDomain () {
      return process.env.VUE_APP_ENGLISH_DOMAIN_URL;
    },
    regularDomain () {
      return process.env.VUE_APP_REGULAR_DOMAIN_URL;
    },
    actualDomain () {
      return window.location.host;
    }
  },
  methods: {
    userIsLogged: function (){
      Api.get('/auth/user_is_logged').then(response => {
        if (response.data == 'not_logged') {
          this.$swal("Error", "Necesita iniciar sesión en el sistema para acceder a esta página", "error");
          this.navigateTo('/login');
        }
      })
      .catch(error => this.errorHandling(error))
    },
    logoutUser: function () {
      Api.post('auth/logout')
      .then(() => {
        this.$swal("Hasta luego", "Sesion cerrada correctamente", "success");
        localStorage.removeItem("auth");
        localStorage.removeItem("userInfo");

        this.$router.push({ 
          name: 'Inicio'
        })
      })
      .catch(error => this.errorHandling(error))
    },

    drawerClose() {
      this.togglerActive = !this.togglerActive;
      this.$emit("drawer-toggle", true);
    },
    minifyDrawer() {
      this.togglerActive = !this.togglerActive;
      this.mini = !this.mini;
      const body = document.getElementsByTagName("body")[0];

      if (body.classList.contains("drawer-mini")) {
        body.classList.remove("drawer-mini");
      } else {
        body.classList.add("drawer-mini");
      }
    },
  },
  watch: {
    toggleActive(val) {
      this.togglerActive = val;
    },
  },
  created() {
    this.userIsLogged();
  }
};
</script>